import React from "react";
const RicosViewerContext = React.createContext(null);
const RicosViewerContextProvider = ({
  contextualData: {
    anchorTarget,
    relValue,
    plugins,
    config,
    helpers,
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick,
    customAnchorScroll,
    textAlignment,
    onNodeClick,
    jsdomMode,
    baseUrl,
    isPrint
  },
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosViewerContext.Provider,
    {
      value: {
        anchorTarget,
        relValue,
        plugins,
        config,
        helpers,
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick,
        customAnchorScroll,
        textAlignment,
        onNodeClick,
        jsdomMode,
        baseUrl,
        isPrint
      }
    },
    children
  );
};
export {
  RicosViewerContext,
  RicosViewerContextProvider
};
//# sourceMappingURL=viewer-context.js.map
